<!-- footer.component.html -->
<footer class="bg-black text-xs text-white font-light text-center py-2  dark:border-gray-700 dark:border-t">
  <span> Developed by PavCon, LLC. &#169; <b>{{ year }}</b>. </span>
  <span> All Rights Reserved </span>
  <span class="font-semibold">{{version}}</span>
</footer>
